import styles from "components/Form/Form.module.scss";

export const formConfig = {
  level: {
    title: "Level",
    elementType: "input",
    elementConfig: {
      id: "level",
      type: "number",
      value: "1",
      step: 1,
      min: 1,
      autoComplete: "off",
      placeholder: "1",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    error: {
      message: "Level is required",
    },
  },
  position: {
    title: "Position",
    elementType: "input",
    elementConfig: {
      id: "position",
      type: "number",
      value: "1",
      step: 1,
      min: 1,
      autoComplete: "off",
      placeholder: "1",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    error: {
      message: "Max channels is required",
    },
  },
  enabled: {
    title: "Enabled",
    elementType: "select",
    elementConfig: {
      id: "enabled",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    options: [
      { value: "", text: "-- set enabled --" },
      { value: "false", text: "No" },
      { value: "true", text: "Yes" },
    ],
    error: {
      message: "",
    },
  },
}